import styled from 'styled-components';

import { ReactComponent as ClockIcon } from '@/assets/icons/clock-icon.svg';
import { ReactComponent as StatusApprovedIcon } from '@/assets/icons/status-approved.svg';
import { ReactComponent as StatusDeclinedIcon } from '@/assets/icons/status-declined.svg';
import { ReactComponent as StatusNeedsActionIcon } from '@/assets/icons/status-needs-action.svg';
import { InvoiceGenerationStatus, VacationStatus } from '@/utils/enums';

const Status = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  white-space: nowrap;
`;

const StyledStatusDot = styled.span<{ $status: string }>`
  width: 14px;
  height: 14px;
  border-radius: 50%;
  transform: translateY(1px);
  display: flex;
  align-items: center;
  justify-content: center;
  color: ${({ theme }) => theme.colors.white};
  background-color: ${({ theme, $status }) =>
    $status === VacationStatus.Approved
      ? theme.colors.success
      : $status === VacationStatus.Pending
        ? theme.colors.warning
        : theme.colors.error};
`;

const renderStatusIcon = (status: InvoiceGenerationStatus) => {
  switch (status) {
    case InvoiceGenerationStatus.Approved:
      return <StatusApprovedIcon />;
    case InvoiceGenerationStatus.Needs_Action:
      return <StatusNeedsActionIcon />;
    case InvoiceGenerationStatus.Pending:
      return <ClockIcon />;
    case InvoiceGenerationStatus.Rejected:
    case InvoiceGenerationStatus.Finances_Rejected:
      return <StatusDeclinedIcon />;
    default:
      return null;
  }
};

const getStatusLabel = (status: InvoiceGenerationStatus) => {
  switch (status) {
    case 'approved':
      return 'Approved';
    case 'pending':
      return 'Pending';
    case 'needs_action':
      return 'Needs Action';
    case 'rejected':
      return 'Rejected';
    case 'finances_rejected':
      return 'Finances Rejected';
    default:
      return '-';
  }
};

interface VacationStatusDotProps {
  status: InvoiceGenerationStatus;
}

const InvoicesStatusDot = ({ status }: VacationStatusDotProps) => {
  return (
    <Status>
      <StyledStatusDot $status={status}>
        {renderStatusIcon(status)}
      </StyledStatusDot>
      {getStatusLabel(status)}
    </Status>
  );
};

export default InvoicesStatusDot;
